import { Vue, Component, Prop } from 'vue-property-decorator';
import { isMicroStandardId, getTaxonomyTags } from '@/utils/utils';
import TaxonomyCard from '../taxonomy-card/taxonomy-card';
import { appConfigService } from '@/providers/services/app/app-config';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'course-card',
    components: {
        'taxonomy-card': TaxonomyCard,
        'material-icon': GoogleMaterialIcon,
    },
})

export default class CourseCard extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private course: any;

    @Prop({ default: false })
    private isMyContent!: boolean;

    private isHideCoursePerf: boolean = false;

    get tags() {
        return this.course.standards;
    }

    get userId() {
        return sessionService.getSession()!.user_id;
    }

    // --------------------------------------------------------------------
    // Actions
    private onPlayCourse(courseId: string) {
        const playerURL = `${window.location.origin}/library/content/courses/play/${courseId}?source=rgo`;
        this.$emit('onOpenPlayer', playerURL);
    }

    private editCourse(courseId: string) {
        const currentRoute = this.$router.currentRoute.path;
        const playerURL = `${window.location.origin}/library/content/courses/edit/${courseId}?redirectUrl=${currentRoute}`;
        window.location.href = playerURL;
    }

    private openPullout() {
        this.$emit('openPullout', this.course);
    }

    private filterCreator(creator: any) {
        this.$emit('filterCreator', creator);
    }

}
